import React from "react";
import { ContainerVentas } from "./styled.components";
//import { configApp } from "utils";

const Ventas = () => {
  return (
    <ContainerVentas>
      <iframe
        height={"100%"}
        width={"100%"}
        src={`https://api-bi.it-strategy.mx/ventarReport.aspx`}
      />
    </ContainerVentas>
  );
};

export default Ventas;
